module.exports = __webpack_public_path__ + "images/paypal/browser_right-03ec1de4.svg";